import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './components/ui/ui.css';
import './components/Layout/Layout.css';

// GitHub Pages SPA redirect recovery
const params = new URLSearchParams(window.location.search);
const redirect = params.get('p');
if (redirect) {
  window.history.replaceState(null, '', decodeURIComponent(redirect));
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
